import React, { useState, useCallback } from "react";
import Logo from "../assets/img/Logo.png";
import "../assets/css/register.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { registerUser } from "../services/API";

const validatePhoneNumber = (phone) => /^[+][0-9]{10,15}$/.test(phone);

const PasswordField = ({
    name,
    placeholder,
    value,
    showPassword,
    toggleVisibility,
    onChange,
}) => (
    <div className="col-12 position-relative">
        <input type={showPassword ? "text" : "password"}
            name={name}
            className="form-control-register"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            required
        />
        <button
            type="button"
            className="password-toggle-btn"
            onClick={toggleVisibility}
        >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
    </div>
);

function RegisterPage() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        phone: "",
        terms: false,
    });

    const [visibility, setVisibility] = useState({
        password: false,
        confirmPassword: false,
    });

    const [validPhone, setValidPhone] = useState(true);
    const [loading, setLoading] = useState(false);

    const handleChange = useCallback((e) => {
        const { name, value } = e.target || {};
        if (name) {
            setFormData((prev) => ({ ...prev, [name]: value }));
            if (name === "phone") setValidPhone(validatePhoneNumber(value));
        } else if (typeof e === "string") {
            setFormData((prev) => ({ ...prev, phone: e }));
            setValidPhone(validatePhoneNumber(e));
        }
    }, []);

    const handleSubmit = useCallback(
        async (e) => {
            e.preventDefault();
            setLoading(true);

            try {
                if (!validPhone) throw new Error("Please enter a valid phone number.");
                if (formData.password !== formData.confirmPassword) throw new Error("Passwords do not match.");

                // Split full name into first and last name
                const [firstName, ...lastNameParts] = formData.name.split(" ");
                const lastName = lastNameParts.join(" ") || "Last Name";

                // API call
                await registerUser({
                    firstName,
                    lastName,
                    email: formData.email,
                    password: formData.password,
                    adsAccountsId: 1 // Temporary value for testing
                });

                alert("Registration successful!");
                window.location.href = "/login";
            } catch (error) {
                alert(error.message);
            } finally {
                setLoading(false);
            }
        },
        [formData, validPhone]
    );

    const toggleVisibility = useCallback(
        (field) => setVisibility((prev) => ({ ...prev, [field]: !prev[field] })),
        []
    );

    return (
        <div className="general-register">
            <div className="register-cuadro">
            <a href="/" className="logo">
                    <img src={Logo} alt="Logo" />
                </a>
                <div className="pt-2 pb-1 text-center">
                    <h3 className="card-title my-3">
                        <a className="text-decoration-none text-dark">
                            User Registration
                        </a>
                    </h3>
                </div>
                <form
                    className="input-register row g-3 needs-validation"
                    onSubmit={handleSubmit}
                    noValidate
                >
                    <div className="col-12">
                        <input
                            type="text"
                            name="name"
                            className="form-control-register"
                            placeholder="Full Name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="col-12">
                        <input
                            type="email"
                            name="email"
                            className="form-control-register"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <PasswordField
                        name="password"
                        placeholder="Password"
                        value={formData.password}
                        showPassword={visibility.password}
                        toggleVisibility={() => toggleVisibility("password")}
                        onChange={handleChange}
                    />

                    <PasswordField
                        name="confirmPassword"
                        placeholder="Confirm Password"
                        value={formData.confirmPassword}
                        showPassword={visibility.confirmPassword}
                        toggleVisibility={() => toggleVisibility("confirmPassword")}
                        onChange={handleChange}
                    />

                    <div className="col-12 position-relative">
                        <PhoneInput
                            country="pe"
                            value={formData.phone}
                            onChange={handleChange}
                            inputClass="form-control-register w-100"
                            required
                        />
                        {!validPhone && formData.phone && (
                            <div className="invalid-feedback">
                                Please enter a valid phone number.
                            </div>
                        )}
                    </div>

                    <div className="boton-register">
                        <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? "Creating account..." : "Create Account"}
                        </button>
                    </div>

                    <a href="/login" className="mb-2 text-center text-decoration-none">Sign In</a>

                </form>
            </div>
        </div>
    );
}

export default RegisterPage;